// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"df5ad397","612":"c35f4faf","681":"c35f4faf","686":"c35f4faf","738":"c35f4faf","835":"8536d56e","848":"c35f4faf","922":"c35f4faf"}[chunkId] + ".chunk.css";
};